import React, {forwardRef, useImperativeHandle, useState} from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@material-ui/core";

const DEFAULT_DIALOG_CONTENT = {
  title: "Admin Portal Confimation",
  message: "Bạn có chắc chắn với quyết định này?",
  cancelText: "Hủy",
  okText: "Tiếp tục"
};

export const ConfirmDialog = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState(DEFAULT_DIALOG_CONTENT);
  const [handleDialog, setHandleDialog] = useState({});

  useImperativeHandle(
    ref,
    () => {
      return {
        openDialogAsync
      };
    },
    []
  );

  const openDialogAsync = ({title, message, cancelText, okText}) => {
    setDialogContent((prev) => {
      return {
        title: title || prev.title,
        message: message || prev.message,
        cancelText: cancelText || prev.cancelText,
        okText: okText || prev.okText
      };
    });
    setOpen(true);
    return new Promise((resolve, reject) => {
      setHandleDialog({
        resolve,
        reject
      });
    });
  };

  const handleClose = () => {
    setOpen(false);
    handleDialog.resolve("CANCEL");
  };

  const handleAction = (key) => {
    setOpen(false);
    handleDialog.resolve(key);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{dialogContent.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {dialogContent.message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleAction("CANCEL")} color="primary" size="small">
          {dialogContent.cancelText}
        </Button>
        <Button variant="outlined" size="small" onClick={() => handleAction("OK")}>
          {dialogContent.okText}
        </Button>
      </DialogActions>
    </Dialog>
  );
});
